import script from "./ActivityCategory.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityCategory.vue?vue&type=script&setup=true&lang=js"

import "./ActivityCategory.vue?vue&type=style&index=0&id=1839d751&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1839d751"]])

export default __exports__